import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase/config";
import { FiEdit2, FiTrash2, FiPlus, FiX } from "react-icons/fi";

const ProductCategories = () => {
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const snap = await getDocs(query(collection(db, "productCategories"), orderBy("name")));
      setCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      if (editId) {
        await updateDoc(doc(db, "productCategories", editId), { name: name.trim(), updatedAt: serverTimestamp() });
      } else {
        await addDoc(collection(db, "productCategories"), { name: name.trim(), createdAt: serverTimestamp() });
      }
      setName(""); setEditId(null); setShowForm(false);
      fetchData();
    } catch (e) { alert("Error: " + e.message); }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    await deleteDoc(doc(db, "productCategories", id));
    fetchData();
  };

  return (
    <AdminLayout>
      <div className="max-w-2xl">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-extrabold text-black">Product Categories</h1>
            <p className="text-sm text-gray-400">Manage shop product categories</p>
          </div>
          <button onClick={() => { setName(""); setEditId(null); setShowForm(true); }}
            className="flex items-center gap-2 px-5 py-2.5 bg-[#e84fa5] text-white font-bold uppercase text-[13px] rounded-lg hover:bg-pink-600 transition">
            <FiPlus /> Add Category
          </button>
        </div>

        {showForm && (
          <div className="bg-white rounded-xl border border-gray-100 p-5 mb-6">
            <h2 className="text-[14px] font-bold mb-4">{editId ? "Edit Category" : "New Category"}</h2>
            <form onSubmit={handleSave} className="flex gap-3">
              <input required value={name} onChange={(e) => setName(e.target.value)}
                className="flex-1 border border-gray-200 rounded-lg px-4 py-2.5 text-[13px] outline-none focus:border-[#e84fa5]"
                placeholder="Category name (e.g. Books, Apparel)" />
              <button type="submit" disabled={saving}
                className="px-5 py-2.5 bg-[#e84fa5] text-white font-bold text-[13px] rounded-lg hover:bg-pink-600 transition disabled:opacity-60">
                {saving ? "..." : editId ? "Update" : "Add"}
              </button>
              <button type="button" onClick={() => { setShowForm(false); setName(""); setEditId(null); }}
                className="p-2.5 text-gray-400 hover:text-gray-700 border border-gray-200 rounded-lg"><FiX /></button>
            </form>
          </div>
        )}

        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          {loading ? (
            <div className="flex justify-center py-10"><div className="w-6 h-6 border-2 border-[#e84fa5] border-t-transparent rounded-full animate-spin"></div></div>
          ) : categories.length === 0 ? (
            <p className="text-center py-10 text-gray-400 text-sm">No categories yet.</p>
          ) : (
            <ul className="divide-y divide-gray-100">
              {categories.map((cat) => (
                <li key={cat.id} className="flex items-center justify-between px-5 py-4">
                  <span className="text-[14px] font-semibold text-black">{cat.name}</span>
                  <div className="flex items-center gap-2">
                    <button onClick={() => { setName(cat.name); setEditId(cat.id); setShowForm(true); }}
                      className="p-2 text-blue-500 hover:bg-blue-50 rounded-lg transition"><FiEdit2 size={14} /></button>
                    <button onClick={() => handleDelete(cat.id)}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition"><FiTrash2 size={14} /></button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default ProductCategories;
